const PaymentData = require('../../components/payment-data/mobile');
const Wrapper = require('./wrapper');

module.exports = Wrapper(PaymentData, 'medium');
